module.exports = __webpack_public_path__ + "static/img/default_img.7d7da3dd.png";